import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../themes/palette"

export const useStyles = makeStyles()(({ spacing }) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: spacing(2),
    listStyle: "none",
    margin: 0,
    padding: 0,

    "& li:empty": {
      display: "none"
    }
  },
  swiperContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: spacing(2, 0)
  },
  accessibilityContainer: {
    borderTop: `1px solid ${blueGrey[100]}`,
    padding: 0,
    marginTop: spacing(3)
  },
  accessibilityLabel: {
    color: blueGrey[500],
    padding: spacing(3, 4)
  },
  drawerPaper: {
    maxHeight: "60vh"
  },
  drawerRoot: {
    zIndex: 99999
  }
}))
